import { DialogContent } from '@mui/material';
import { Invoice } from '@thro-types/billing';

import { useTranslation } from 'react-i18next';

import { ConfirmationDialog } from 'app/components';
import { translations } from 'locales/i18n';

import { getDistinctTaxes } from '../utils';

interface ApproveSplitDialogProps {
  open: boolean;
  handleClose: () => void;
  onConfirm: () => void;
  invoice: Invoice;
}

export const ApproveSplitDialog = ({
  open,
  handleClose,
  onConfirm,
  invoice
}: ApproveSplitDialogProps) => {
  const { t } = useTranslation();

  const taxRates = getDistinctTaxes(invoice);

  return (
    <ConfirmationDialog
      open={open}
      title={t(translations.pages.billingFinance.confirmationDialog.approveSplitInvoiceTitle())}
      onClose={handleClose}
      onConfirm={onConfirm}
    >
      {t(translations.pages.billingFinance.confirmationDialog.approveSplitInvoiceDialog(), {
        count: taxRates.length
      })}
      <DialogContent>
        {taxRates.map(taxRate => (
          <li key={taxRate.id}>{`${taxRate.taxRate}% - ${taxRate.text}`}</li>
        ))}
      </DialogContent>
    </ConfirmationDialog>
  );
};
